import * as React from 'react';
import { useSelector } from 'react-redux';
import { Experiment } from '@cian/experiments/ab';
import { CianLogoSign } from '@cian/ui-kit-design-tokens/logo';

import { DownloadAppBannerContainer } from '../DownloadAppBannerContainer';
import { LinkToFullVersionContainer } from '../LinkToFullVersionContainer';
import { MobileFooterLayout } from '../../components/MobileFooterLayout';
import { MOBILE_FOOTER_TYPES } from '../../constants/footerTypes';
import { IApplicationState } from '../../types/redux';
import { useIsSearchPage } from '../../hooks/useIsSearchPage';
import { AUD_MOBILE_REDESIGN_OBJECTCARD, NEW_MAIN_PAGE_EXPERIMENT } from '../../constants/experiments';
import { useIsMainPage } from '../../hooks/useIsMainPage';

export const MobileFooterContainer: React.FC = () => {
  const footerType = useSelector((state: IApplicationState) => state.footerType);
  const isSearchPage = useIsSearchPage();
  const isMainPage = useIsMainPage();

  if (!MOBILE_FOOTER_TYPES.includes(footerType)) {
    return null;
  }

  if (isSearchPage) {
    return (
      <>
        <Experiment name={AUD_MOBILE_REDESIGN_OBJECTCARD} group="A" default>
          <MobileFooterLayout type={footerType}>
            <DownloadAppBannerContainer />
            <CianLogoSign data-testid="CianLogo" size={18} cursor="default" />
            <LinkToFullVersionContainer />
          </MobileFooterLayout>
        </Experiment>

        <Experiment name={AUD_MOBILE_REDESIGN_OBJECTCARD} group="B">
          <MobileFooterLayout type={footerType} isRedesign>
            <DownloadAppBannerContainer isRedesign />
            <LinkToFullVersionContainer isRedesign />
            <CianLogoSign data-testid="CianLogo" size={18} cursor="default" />
          </MobileFooterLayout>
        </Experiment>
      </>
    );
  }

  if (isMainPage) {
    return (
      <>
        <Experiment name={NEW_MAIN_PAGE_EXPERIMENT} group="A" default>
          <MobileFooterLayout type={footerType}>
            <DownloadAppBannerContainer />
            <CianLogoSign data-testid="CianLogo" size={18} cursor="default" />
            <LinkToFullVersionContainer />
          </MobileFooterLayout>
        </Experiment>
        <Experiment name={NEW_MAIN_PAGE_EXPERIMENT} group="B">
          <MobileFooterLayout type={footerType} isLowTopPadding={true}>
            <DownloadAppBannerContainer isMainPageRedesign={true} />
            <CianLogoSign data-testid="CianLogo" size={18} cursor="default" />
            <LinkToFullVersionContainer />
          </MobileFooterLayout>
        </Experiment>
      </>
    );
  }

  return (
    <MobileFooterLayout type={footerType}>
      <DownloadAppBannerContainer />
      <CianLogoSign data-testid="CianLogo" size={18} cursor="default" />
      <LinkToFullVersionContainer />
    </MobileFooterLayout>
  );
};
